interface UsageMeterProps {
  label: string;
  used: number;
  limit: number;
  className?: string;
}

export function UsageMeter({ label, used, limit, className = '' }: UsageMeterProps) {
  const pct = limit > 0 ? Math.min(100, (used / limit) * 100) : 0;
  const isHigh = pct >= 80;
  const isMax = pct >= 100;
  return (
    <div className={className}>
      <div className="flex justify-between text-sm mb-1">
        <span className="text-slate-300">{label}</span>
        <span className={isMax ? 'text-danger font-medium' : isHigh ? 'text-amber-400' : 'text-slate-400'}>
          {used.toLocaleString()} / {limit >= 999999 ? 'Unlimited' : limit.toLocaleString()}
        </span>
      </div>
      <div className="h-2 bg-navy-700 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${isMax ? 'bg-danger' : isHigh ? 'bg-amber-400' : 'bg-helm-500'}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
